// /record/ page entry: the guided self-record flow. Firebase is NOT imported here; the send
// step loads it with a dynamic import() so the page paints and records without the SDK.
import { start } from '../record/app.js';
import { logger } from '../lib/log.js';

start().catch((e) => {
  logger('record').error('record_init_failed', { message: e && e.message, stack: e && e.stack });
});
